import { render, staticRenderFns } from "./IconIdentificationSolid.vue?vue&type=template&id=479a38f5"
import script from "./IconIdentificationSolid.vue?vue&type=script&lang=js"
export * from "./IconIdentificationSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports